import { App } from 'vue';
import { trace, SpanStatusCode, SpanKind } from '@opentelemetry/api';
import { getTracer } from '@/config/telemetry';

// 创建应用级别的tracer
const tracer = getTracer('vue-app', '1.0.0');

// API调用追踪函数
export function traceApiCall(url: string, method: string = 'GET') {
  try {
    let parsedUrl: URL | null = null;

    // 尝试解析URL
    try {
      parsedUrl = new URL(url, window.location.origin);
    } catch {
      console.warn('Invalid URL for tracing:', url);
    }

    const span = tracer.startSpan(`${method.toUpperCase()} ${parsedUrl?.pathname || url}`, {
      kind: SpanKind.CLIENT,
      attributes: {
        'http.method': method.toUpperCase(),
        'http.url': url,
        'component': 'http-client'
      }
    });

    // 如果成功解析URL，添加更多属性
    if (parsedUrl) {
      span.setAttributes({
        'http.host': parsedUrl.host,
        'http.scheme': parsedUrl.protocol.replace(':', ''),
        'http.target': parsedUrl.pathname + parsedUrl.search
      });
    }

    return span;
  } catch (error) {
    console.warn('Failed to trace API call:', error);
    return {
      setAttributes: () => {},
      addEvent: () => {},
      recordException: () => {},
      setStatus: () => {},
      end: () => {}
    };
  }
}

// 检查追踪是否初始化
export function isInitialized(): boolean {
  try {
    return !!tracer;
  } catch {
    return false;
  }
}

// Vue插件 - 简化版，专注API追踪
export default {
  install(app: App) {
    // 全局属性 - 只提供API追踪相关功能
    app.config.globalProperties.$trace = {
      traceApiCall,
      isInitialized
    };

    // 组合式API provide
    app.provide('$trace', {
      traceApiCall,
      isInitialized
    });
  }
};
